module.exports = __webpack_public_path__ + "static/gamer-3eb4ca431a9e45b084f4ba8dc2a6e434.jpg";